class SiteUtils {
  isFree () {
    const subDomain = location.hostname.split('.')[0]
    return subDomain === 'admin' || Number.isInteger(subDomain)
    // ↓ストレージ版の確認用、上記const&returnをコメントアウト
    // return true
  }
}

export default new SiteUtils()
